'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import MovementRegistrationPopup from '@/components/common/MovementRegistrationPopup';

const CTASection = () => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <section className="py-16 lg:py-24 bg-primary">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-headline font-bold text-primary-foreground mb-6">
            Ready to Begin Your Transformation?
          </h2>
          <p className="text-lg text-primary-foreground/90 font-body max-w-3xl mx-auto mb-8">
            Join thousands of people worldwide who are choosing peace, forgiveness, and living with no enemy. Your journey starts today.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="bg-card rounded-xl p-8 text-center shadow-lg">
            <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="CalendarIcon" size={32} className="text-accent-foreground" />
            </div>
            <h3 className="text-xl font-headline font-bold text-primary mb-2">
              Start 30-Day Journey
            </h3>
            <p className="text-sm text-foreground font-body mb-4">
              Begin your preparation today with daily guided activities
            </p>
            <button
              onClick={() => setShowPopup(true)}
              className="w-full px-6 py-3 bg-accent text-accent-foreground rounded-lg font-cta text-sm font-bold transition-all duration-300 hover:scale-105"
            >
              Enroll Now
            </button>
          </div>

          <div className="bg-card rounded-xl p-8 text-center shadow-lg">
            <div className="w-16 h-16 bg-peaceful-teal rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="UserGroupIcon" size={32} className="text-white" />
            </div>
            <h3 className="text-xl font-headline font-bold text-primary mb-2">
              Find Local Chapter
            </h3>
            <p className="text-sm text-foreground font-body mb-4">
              Connect with community members in your area
            </p>
            <button className="w-full px-6 py-3 bg-muted text-foreground rounded-lg font-cta text-sm font-bold transition-all duration-300 hover:bg-background">
              Search Chapters
            </button>
          </div>

          <div className="bg-card rounded-xl p-8 text-center shadow-lg">
            <div className="w-16 h-16 bg-transformation-gold rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="ArrowDownTrayIcon" size={32} className="text-accent-foreground" />
            </div>
            <h3 className="text-xl font-headline font-bold text-primary mb-2">
              Download Resources
            </h3>
            <p className="text-sm text-foreground font-body mb-4">
              Access complete guide and preparation materials
            </p>
            <button className="w-full px-6 py-3 bg-muted text-foreground rounded-lg font-cta text-sm font-bold transition-all duration-300 hover:bg-background">
              Get Toolkit
            </button>
          </div>
        </div>

        <div className="text-center">
          <p className="text-base text-primary-foreground/80 font-body mb-6">
            Have questions? Explore our comprehensive resources or connect with our community.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              href="/festival-guide"
              className="px-8 py-3 bg-card text-primary rounded-lg font-cta text-sm font-bold transition-all duration-300 hover:scale-105 hover:shadow-lg"
            >
              Browse Resources
            </Link>
            <Link
              href="/community-stories"
              className="px-8 py-3 bg-transparent border-2 border-primary-foreground text-primary-foreground rounded-lg font-cta text-sm font-bold transition-all duration-300 hover:bg-primary-foreground hover:text-primary"
            >
              Read Success Stories
            </Link>
          </div>
        </div>
      </div>

      {showPopup && (
        <MovementRegistrationPopup
          sourcePage="festival-guide-cta"
          isOpen={showPopup}
          onClose={() => setShowPopup(false)}
        />
      )}
    </section>
  );
};

export default CTASection;